/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import { EditChargebeeInfoIconPropTypes } from "../admin/billing/lib/types";
import { StyledEditButton } from "../admin/billing/lib/styles";

const editPencil = require("../svg/editPencil.svg");

const StyledImage = styled.img`
  position: absolute;
  height: auto;
  width: auto;
`;

const StyledEditButtonCentered = styled(StyledEditButton)`
  top: 8px;
`;

const EditChargebeeInfoIcon = ({
  altText,
  amplitudeEventName,
  closeModalCallback,
  openPortal,
  portalSection,
  testId,
}: EditChargebeeInfoIconPropTypes): React.ReactElement => {
  const handleClick = async (event): Promise<void> => {
    try {
      window.amplitude.track(`${amplitudeEventName} (start)`);
      openPortal(event, portalSection, closeModalCallback);
    } catch (error) {
      window.amplitude.track(`${amplitudeEventName} (fail)`);
      datadogRum.addError(error);
    }
  };

  return (
    <StyledEditButtonCentered
      onClick={handleClick}
      size="small"
      testId={testId}
      variant="icon"
    >
      <StyledImage src={editPencil} alt={altText} />
    </StyledEditButtonCentered>
  );
};

export default EditChargebeeInfoIcon;
